(function () {
    'use strict';

    var $ = avm.require('jquery'),
        url = document.location.href,
        acceptedHost = ['id-stage.avg.com','id.avg.com'],
        unserializedUrl = avm.require('avast.url.unserialize'),
        $button = $('.urlTarget');

        if (unserializedUrl(url)['link'] != undefined) {
            var link = unserializedUrl(url)['link'],
                domain = new URL(link);

            if (acceptedHost.indexOf(domain.host) > -1) {
                $button.attr('href', unserializedUrl(url)['link']);
            }
        }

})()
